"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var general_1 = require("utils/general");
var constants_1 = require("../Logo/constants");
var StyledAvatar = (0, styles_1.styled)(material_1.Avatar, { shouldForwardProp: (0, general_1.omitProps)('size', 'color') })(function (_a) {
    var theme = _a.theme, _b = _a.size, size = _b === void 0 ? 'md' : _b, color = _a.color;
    return (__assign(__assign({ border: "1px solid ".concat(color) }, (size && {
        width: constants_1.IMG_SIZES[size].size,
        height: constants_1.IMG_SIZES[size].size,
        fontSize: constants_1.IMG_SIZES[size].fontSize,
    })), { '&.MuiAvatar-colorDefault': {
            fontWeight: theme.typography.fontWeightMedium,
            background: color,
        } }));
});
var Avatar = function (_a) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? 'md' : _b, props = __rest(_a, ["label", "size"]);
    var colors = ['#D0D9DF', '#9ADEC4', '#FBD5E0', '#87D4F7'];
    var _c = __read(react_1.default.useState(0), 2), randomNum = _c[0], setRandomNum = _c[1];
    react_1.default.useEffect(function () {
        setRandomNum(Math.floor(Math.random() * 4));
    }, [randomNum]);
    return ((0, jsx_runtime_1.jsx)(StyledAvatar, __assign({ alt: label, size: size, variant: "circular", color: colors[randomNum] }, props, { children: !props.src && (label === null || label === void 0 ? void 0 : label[0].toUpperCase()) })));
};
exports.default = Avatar;
